import Axios from "axios";
import {
    SET_HRM_EMPLOYEE_BANK_SETUP_LIST,
    UNSET_HRM_EMPLOYEE_BANK_SETUP_LIST,
} from "@/store/mutation-types";
import { saveUpdateHrmEmployeeBankSetup, getHrmEmployeeBankSetupList } from "@/store/api";

// initial state
const state = {
    getHrmEmployeeBankSetupList: [],
};

const getters = {
    getHrmEmployeeBankSetupList(state) {
        return state.getHrmEmployeeBankSetupList;
    },
};

const mutations = {
    [SET_HRM_EMPLOYEE_BANK_SETUP_LIST](state, data) {
        state.getHrmEmployeeBankSetupList = data;
    },
    [UNSET_HRM_EMPLOYEE_BANK_SETUP_LIST](state) {
        state.getHrmEmployeeBankSetupList = [];
    },
};

const actions = {
    saveUpdateHrmEmployeeBankSetup({ commit }, data) {
        commit("SET_LOADING", { color: "primary" });
        return new Promise((resolve, reject) => {
            Axios.post(saveUpdateHrmEmployeeBankSetup, data)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING");
                });
            }
        );
    },

    getHrmEmployeeBankSetupList({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.get(getHrmEmployeeBankSetupList, data)
                .then(function (response) {
                    commit("SET_HRM_EMPLOYEE_BANK_SETUP_LIST", response.data.data);
                    resolve(response.data.data);
                })
                .catch(function (error) {
                    commit("UNSET_HRM_EMPLOYEE_BANK_SETUP_LIST");
                    reject(error);
                })
                .then((always) => {});
            }
        );
    },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
